module.exports = __webpack_public_path__ + "rachel-schaaf-8626c4b06335e1bf7452a3944f93af4a.webp";